/*================ Templates ================*/

theme.equalHeight = function () {
  var $columns = $(".equalHeightColumn");
  $columns.height("initial");
  var height = 0;
  $columns.each(function () {
    if ($(this).height() > height) {
      height = $(this).height();
    }
  });
  $columns.height(height);
};

theme.ariaHover = function () {
  $(".accessibleNav > li").on("focusin", function () {
    $(".accessibleNav > li").removeClass("hover");
    $(this).addClass("hover");
    $(this).children(".nav__link").attr("aria-expanded", "true");
  });
};

theme.floatLabels = function () {
  $(function () {
    $(".float__wrapper input, .float__wrapper textarea")
      .on("checkval", function () {
        var label = $(this).prev("label");
        if (this.value !== "") {
          label.addClass("label--float ");
        } else {
          label.removeClass("label--float ");
        }
      })
      .on("keyup", function () {
        $(this).trigger("checkval");
      });
    $(".float__wrapper input, .float__wrapper textarea").val(
      function (index, value) {
        if (value.length) {
          var label = $(this).prev("label");
          label.addClass("label--float ");
        }
        return value;
      }
    );
  });
};

theme.smoothScroll = function () {
  $('a[href*="#"]:not([href="#"])').click(function (event) {
    if (
      location.pathname.replace(/^\//, "") ==
        this.pathname.replace(/^\//, "") ||
      location.hostname == this.hostname
    ) {
      var target = $(this.hash);
      target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
      if (target.length) {
        event.preventDefault();
        $("html,body").animate(
          {
            scrollTop: target.offset().top,
          },
          1000
        );
      }
    }
  });
};

theme.fullHeight = function () {
  var windowHeight = $(window).height();
  var heroHeight = windowHeight;
  heroHeight = windowHeight * 0.8;

  if ($("#shopify-section-header").attr("data-header-sticky") != "true") {
    heroHeight -= $("#shopify-section-header").height();
  }
  $(".index-sections > .shopify-section:first-child > .use_screen_full")
    .height(heroHeight)
    .css("min-height", "initial");
  $(
    ".index-sections > .shopify-section:first-child > .use_screen_full.homepage-slideshow .slideshow__slide"
  ).height(heroHeight);
  $(
    ".index-sections > .shopify-section:first-child > .use_screen_full.homepage-double .double__block"
  ).height(heroHeight);
};

theme.videoPopupGeneric = function () {
  $("[data-video-popup]").magnificPopup({
    type: "iframe",
    mainClass: "mfp-fade",
    removalDelay: 160,
    closeBtnInside: false,
    preloader: false,
    fixedContentPos: false,
    iframe: {
      patterns: {
        youtube: {
          src: "//www.youtube.com/embed/%id%?autoplay=1&rel=0&showinfo=0",
        },
      },
    },
  });
};

theme.showTitle = function () {
  if ($(".sectionTitle").length) {
    $(".templateTitle").remove();
  } else {
    $(".templateTitle").show();
    $(".templateTitle").css("opacity", "1");
  }
};

theme.matchHeight = function () {
  $(".equalOverflowHeight").css("min-height", function () {
    var blockHeights = $(".preventOverflowContent", $(this))
      .map(function () {
        return $(this).height();
      })
      .get();
    var tallest = Math.max.apply(null, blockHeights);
    return tallest + 30;
  });
};

theme.accordion = function () {
  $("body").on("click", "[data-accordion-toggle]", function (e) {
    var $accordion = $(this).closest("[data-accordion]"),
      $accordionItem = $(this).closest("[data-accordion-item]"),
      $accordionContent = $accordionItem.find("[data-accordion-content]");

    if ($accordionItem.hasClass("in")) {
      $accordionContent.slideUp("fast");
      setTimeout(function () {
        $accordionItem.removeClass("in");
      }, 200);
    } else {
      if ($accordion.find("[data-accordion-item].in").length) {
        $accordion.find("[data-accordion-content]").slideUp("fast");
        $accordion.find("[data-accordion-item]").removeClass("in");
        setTimeout(function () {
          $accordionContent.slideDown("fast");
          setTimeout(function () {
            $accordionItem.addClass("in");
          }, 200);
        }, 200);
      } else {
        $accordionContent.slideDown("fast");
        setTimeout(function () {
          $accordionItem.addClass("in");
        }, 200);
      }
    }
  });
};

theme.$body = $("body");
theme.bodyHeight = theme.$body.height();
theme.watchBodyHeight = function () {
  if (theme.bodyHeight != theme.$body.height()) {
    $(window).resize();
    theme.bodyHeight = theme.$body.height();
  }
  setTimeout(theme.watchBodyHeight, 10000);
};

theme.slickSlider = function () {
  $(`[data-slick-slider]`).slick();
};

// https://www.w3schools.com/js/js_cookies.asp
theme.setCookie = function (cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
};

theme.getCookie = function (cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

theme.getVariantAvailability = function (productId, variant) {
  if (productId === undefined || variant === undefined) {
    return false;
  }

  var availablities = false;
  if (
    $('[product-json-availability][data-product-id="' + productId + '"]').length
  ) {
    availablities = JSON.parse(
      $(
        '[product-json-availability][data-product-id="' + productId + '"]'
      ).html()
    );
  }

  if (!variant) return false;

  if (
    typeof availablities[variant.id] === "undefined" ||
    typeof availablities[variant.id].available === "undefined"
  ) {
    return variant.available;
  }

  return availablities[variant.id].available;
};

theme.getVariantStockStatus = function (productId, variant) {
  if (productId === undefined || variant === undefined) {
    return false;
  }

  let stockStatus = false;
  if (
    $('[product-json-availability][data-product-id="' + productId + '"]').length
  ) {
    stockStatus = JSON.parse(
      $(
        '[product-json-availability][data-product-id="' + productId + '"]'
      ).html()
    );
  }

  if (
    typeof stockStatus[variant.id] === "undefined" ||
    typeof stockStatus[variant.id].stock_status === "undefined"
  ) {
    return false;
  }

  return stockStatus[variant.id].stock_status;
};

theme.getVariantMetafields = function (productId, variant) {
  if (productId === undefined || variant === undefined) {
    return false;
  }

  var variantMetafields = false;
  if (
    $('[product-json-metafields][data-product-id="' + productId + '"]').length
  ) {
    variantMetafields = JSON.parse(
      $('[product-json-metafields][data-product-id="' + productId + '"]').html()
    );
  }

  if (
    !variant ||
    typeof variantMetafields[variant.id] === "undefined" ||
    typeof variantMetafields[variant.id].global === "undefined"
  ) {
    return false;
  }

  return variantMetafields[variant.id].global;
};

theme.navBarScrollBehavior = () => {
  const header = document.getElementById("shopify-section-header");
  const infoBar = header.querySelector(".info-bar");
  let isMobile = window.matchMedia("(max-width: 768px)").matches; // Adjust breakpoint as needed

  let heightQuarter = window.innerHeight / 4;

  let lastScrollY = window.scrollY;
  let isHidden = false; // To prevent redundant style applications

  window.addEventListener("resize", () => {
    isMobile = window.matchMedia("(max-width: 768px)").matches;
    heightQuarter = window.innerHeight / 4;
  });

  // add a css variable to the body with the height of the header
  updateHeaderHeight(
    header.getBoundingClientRect().height,
    isHidden,
    isMobile,
    infoBar.getBoundingClientRect().height
  );

  window.addEventListener("scroll", () => {
    const currentScrollY = window.scrollY;
    const scrollingDown = currentScrollY > lastScrollY;
    const passedSibling = currentScrollY > heightQuarter;
    const headerHeight = header.getBoundingClientRect().height;

    // if (isMobile) {
    //   // Mobile: Toggle the info-bar
    //   if (scrollingDown && passedSibling && !isHidden) {
    //     // move the header up to the same height as the info-bar
    //     const infoBarHeight = infoBar.getBoundingClientRect().height;
    //     header.style.top = `-${infoBarHeight}px`;
    //     isHidden = true;
    //   } else if (!scrollingDown && isHidden) {
    //     // move the header back down
    //     header.style.top = "0";
    //     isHidden = false;
    //   }
    // } else {

    // }

    // Desktop: Toggle the entire header
    if (scrollingDown && passedSibling && !isHidden) {
      const headerHeight = header.getBoundingClientRect().height;
      header.style.top = `-${headerHeight}px`;
      isHidden = true;
    } else if (!scrollingDown && isHidden) {
      header.style.top = "0";
      isHidden = false;
    }

    lastScrollY = currentScrollY; // Update scroll position
    updateHeaderHeight(
      headerHeight,
      isHidden,
      isMobile,
      infoBar.getBoundingClientRect().height
    );
  });

  function updateHeaderHeight(
    headerHeight,
    isHidden = false,
    isMobile = false,
    infoBarHeight = 0
  ) {
    // if (!isMobile) {
    //   document.body.style.setProperty(
    //     "--header-height",
    //     isHidden ? "0px" : `${headerHeight}px`
    //   );
    // } else {
    //   document.body.style.setProperty(
    //     "--header-height",
    //     isHidden ? `${headerHeight - infoBarHeight}px` : `${headerHeight}px`
    //   );
    // }
    document.body.style.setProperty(
      "--header-height",
      isHidden ? "0px" : `${headerHeight}px`
    );
  }
};

theme.init = function () {
  theme.ariaHover();
  theme.smoothScroll();
  theme.floatLabels();
  theme.showTitle();
  theme.watchBodyHeight();
  theme.accordion();
  theme.slickSlider();
  theme.navBarScrollBehavior();
  theme.changeCurrency();
  theme.setupDataLayerTriggers();
};

$(theme.init);

/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains code for the Customer Addresses template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function () {
  var $newAddressForm = $("#AddAddress");

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector(
      "AddressCountryNew",
      "AddressProvinceNew",
      {
        hideElement: "AddressProvinceContainerNew",
      }
    );
  }

  // Initialize each edit form's country/province selector
  $(".address-country-option").each(function () {
    var formId = $(this).data("form-id");
    var countrySelector = "AddressCountry_" + formId;
    var provinceSelector = "AddressProvince_" + formId;
    var containerSelector = "AddressProvinceContainer_" + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector,
    });
  });

  // Toggle new/edit address forms
  $(".address-new-toggle").on("click", function () {
    $newAddressForm.toggleClass("hide");
  });

  $(".address-edit-toggle").on("click", function () {
    var formId = $(this).data("form-id");
    $("#EditAddress_" + formId).toggleClass("hide");
  });

  $(".address-delete").on("click", function (event) {
    event.preventDefault(); // Prevent the default form action

    var $el = $(this);
    var formId = $el.data("form-id");
    var confirmMessage = $el.data("confirm-message");

    if (
      confirm(confirmMessage || "Are you sure you wish to delete this address?")
    ) {
      // continue with event
      event.target.form.submit();
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains code for the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function () {
  var config = {
    recoverPasswordForm: "#RecoverPassword",
    hideRecoverPasswordLink: "#HideRecoverPasswordLink",
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on("click", onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on("click", onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === "#recover") {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    var emailValue = $("#CustomerEmail").val();
    $("#RecoverEmail").val(emailValue);
    $("#RecoverPasswordForm").toggleClass("hide");
    $("#CustomerLoginForm").toggleClass("hide");
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $(".reset-password-success");

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $("#ResetSuccess").removeClass("hide");
  }
})();

/**
 * Password Page
 * ------------------------------------------------------------------------------
 * Login modal for the password page
 *
 */

// @todo: cleanup - delete ??
theme.passwordPage = (function () {
  $(".js-toggle-login-modal").magnificPopup({
    type: "inline",
    mainClass: "mfp-fade",
    closeOnBgClick: false,
    closeBtnInside: false,
    closeOnContentClick: false,
    tClose: "x",
    removalDelay: 500,
    callbacks: {
      open: function () {
        window.setTimeout(function () {
          document.getElementById("password").focus();
        }, 50);
      },
      close: function () {
        window.setTimeout(function () {
          document.getElementById("email").focus();
        }, 50);
      },
    },
  });
  if ($(".storefront-password-form .errors").length) {
    $(".js-toggle-login-modal").click();
  }
})();

/*================ Sections ================*/
function loadYoutubeAPI() {
  if (!window.YoutubeAPILoading) {
    var tag = document.createElement("script");

    tag.src = "https://www.youtube.com/iframe_api";
    document.getElementsByTagName("head")[0].appendChild(tag);
    window.YoutubeAPILoading = true;
  }
}
function onYouTubeIframeAPIReady() {
  window.YoutubeAPILoaded = true;
  $("body").trigger("YoutubeAPILoaded");
}

theme.Footer = (function () {
  function Footer(container) {
    var $container = (this.$container = $(container)),
      id = $container.attr("data-section-id"),
      fixedFooter = $container.attr("data-fixed") == "true";

    if (fixedFooter) {
      this.fixedFooter();
    }
  }

  Footer.prototype = $.extend({}, Footer.prototype, {
    fixedFooter: function () {
      var $container = this.$container,
        $mainContent = $(".main-content");

      $(window).on(
        "resize",
        themeUtils.general.debounce(function () {
          var windowWidth = $(window).width(),
            windowHeight = $(window).height(),
            mainContentHeight = $mainContent.outerHeight(),
            footerHeight = $container.outerHeight(),
            fixed = true;

          if (
            windowWidth < 480 ||
            windowHeight < footerHeight ||
            windowHeight > mainContentHeight
          ) {
            fixed = false;
          }
        }, 200)
      );
    },
  });
  return Footer;
})();

theme.Slideshow = (function () {
  function Slideshow(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr("data-section-id");
    var slideshow = (this.slideshow = "#slideshow-" + sectionId);
    var $slideshow = (this.$slideshow = $(this.slideshow));

    this.init();
  }

  Slideshow.prototype = $.extend({}, Slideshow.prototype, {
    init: function () {
      this.$slideshow.on("init", function (event, slick) {
        /*
        var $slider = slick.$slider;
        var $currentSlide = $slider.find('.slick-current');
        var currentColor = $currentSlide.find('[data-color]').data('color');

        slick.$prevArrow.addClass(currentColor);
        slick.$nextArrow.addClass(currentColor);
        */
      });
      this.$slideshow.on(
        "beforeChange",
        function (event, slick, currentSlide, nextSlide) {
          /*
        var $slider = slick.$slider;
        var $currentSlide = $slider.find('.slick-current');
        var $nextSlide = $slider.find('[data-slick-index="' + nextSlide + '"]');
        var nextColor = $nextSlide.find('[data-color]').data('color');

        slick.$prevArrow.removeClass('homepage--white homepage--light homepage--splash homepage--dark');
        slick.$prevArrow.addClass(nextColor);

        slick.$nextArrow.removeClass('homepage--white homepage--light homepage--splash homepage--dark');
        slick.$nextArrow.addClass(nextColor);
        */
        }
      );
      this.$slideshow.slick({
        autoplay: this.$slideshow.data("autoplay"),
        autoplaySpeed: this.$slideshow.data("speed"),
        prevArrow: this.$container.find("[data-prev-arrow]"),
        nextArrow: this.$container.find("[data-next-arrow]"),
        adaptiveHeight: false,
        dots: true,
        arrows: false,
        fade: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              fade: false,
            },
          },
        ],
      });
    },
    onUnload: function () {
      delete theme.slideshows[this.slideshow];
    },
    onBlockSelect: function (evt) {
      var $slideshow = $(this.slideshow);

      // Ignore the cloned version
      var $slide = $(
        ".slideshow__slide--" + evt.detail.blockId + ":not(.slick-cloned)"
      );
      var slideIndex = $slide.data("slick-index");

      // Go to selected slide, pause autoplay
      $slideshow.slick("slickGoTo", slideIndex).slick("slickPause");
    },
  });
  return Slideshow;
})();

theme.Blog = (function () {
  function Blog(container) {
    var $container = (this.$container = $(container));
    var id = $container.attr("data-section-id");

    this.initSlider();
  }

  Blog.prototype = $.extend({}, Blog.prototype, {
    initSlider: function () {
      var $container = this.$container,
        $articleItems = $container.find("[data-article-items]");

      if (!$articleItems.length || Shopify.designMode) {
        return;
      }

      $articleItems.slick({
        dots: true,
      });
    },
  });

  return Blog;
})();

// @todo: cleanup - delete ??
theme.Columns = (function () {
  function Columns(container) {
    theme.videoPopupGeneric();
  }
  return Columns;
})();

theme.ImageBlocks = (function () {
  function ImageBlocks(container) {
    var $container = (this.$container = $(container));
    this.initSlider();
  }

  ImageBlocks.prototype = $.extend({}, ImageBlocks.prototype, {
    initSlider: function () {
      var $container = this.$container,
        $slider = $container.find("[data-image-block-slider]");

      if ($slider.length) {
        $slider.each(function () {
          var dotsClass = $(this).attr("data-dots-class") || "slick-dots";
          $(this).slick({
            arrows: false,
            autoplay: false,
            autoplaySpeed: 6000,
            speed: 300,
            dots: true,
            appendDots: $container.find("[slick-dots-container]"),
            dotsClass: dotsClass,
          });
        });
      }
    },
  });

  return ImageBlocks;
})();

// @todo: cleanup - delete ??
theme.LPBuyProduct = (function () {
  function LPBuyProduct(container) {
    var $container = (this.$container = $(container)),
      id = $container.attr("data-section-id"),
      passwordMd5 = $container.attr("data-password");

    this.init();
    this.genderToggle();
    this.filterColorSwatches();
    this.selectColor();
    this.pageModal();
    this.initSlider();

    var scope = this;
    $container.on("ajaxLoaded", "[ajax-product-section-wrap]", function () {
      scope.filterColorSwatches();
      scope.removeUpsell();
    });

    if (typeof passwordMd5 !== "undefined") {
      this.password(passwordMd5);
    }
  }

  LPBuyProduct.prototype = $.extend({}, LPBuyProduct.prototype, {
    init: function () {
      var $container = this.$container;
      this.removeUpsell();
    },
    genderToggle: function () {
      var $container = this.$container;
      $container.find("[data-gender-toggle]").click(function () {
        var gender = $(this).attr("data-gender-toggle"),
          $targetGender = $container.find('[data-gender="' + gender + '"]');

        if (!$targetGender.is(":visible")) {
          $container.find("[data-gender]").hide();
          $container.find("[data-gender-toggle]").each(function () {
            if ($(this).hasClass("outlined")) {
              $(this).removeClass("outlined");
            } else {
              $(this).addClass("outlined");
            }
          });
          $targetGender.show();
          if ($targetGender.find(".slick-slider").length) {
            $targetGender.find(".slick-slider").slick("setPosition");
          }
        }
        $(window).trigger("resize");
      });
    },
    removeUpsell: function () {
      var $container = this.$container,
        $productUpsell = $container.find("[data-upsell-pdp]");

      if (!$container.find("[data-upsell-pdp]").length) {
        return;
      } else {
        $productUpsell.remove();
      }
    },
    filterColorSwatches: function () {
      var $container = this.$container,
        $productSections = $container.find('[data-section-type="product"]');

      if (!$container.find("[data-product-colors]").length) {
        return;
      }

      var productColors = JSON.parse(
        $container.find("[data-product-colors]").html()
      );
      $productSections.each(function () {
        var $productSection = $(this),
          $colorSwatchWrapper = $productSection.find(".swatch-wrapper--color"),
          $colorSwatchItems = $colorSwatchWrapper.find(".swatch__item");

        $colorSwatchItems.hide();

        for (var i = 0; i < productColors.length; i++) {
          $colorSwatchItems
            .find(".swatch__link")
            .filter('[title="' + productColors[i] + '"]')
            .closest(".swatch__item")
            .show()
            .addClass("is-visible");
        }

        $colorSwatchWrapper.find(".swatch").each(function () {
          if (
            $(this).find(".swatch__item").filter(".is-visible").length === 0
          ) {
            $(this).hide().remove();
          }
        });
      });
    },
    selectColor: function () {
      var $container = this.$container;

      $container.find('form[action="/cart/add"]').each(function () {
        var $form = $(this),
          $colorSwatchWrapper = $form.find(".swatch-wrapper--color");

        if (!$colorSwatchWrapper.length) {
          return;
        }

        $colorSwatchWrapper
          .find("[data-swatch-item]")
          .first()
          .find("[data-swatch-link]")
          .click();
      });
    },
    password: function (passwordMd5) {
      // @todo: cleanup move this to a separate file or delete
      $container = this.$container;

      $container.find("[data-password-submit]").click(function () {
        var inputMd5 = $.md5(
          $container.find("[data-password-input]").val().toLowerCase()
        );
        if (passwordMd5 === inputMd5) {
          $container.find("[data-password-section]").hide();
          $container.find("[data-password-protected]").show();
          $container
            .find("[data-password-protected]")
            .find(".slick-slider")
            .slick("setPosition");
        } else {
          $container.find("[data-password-invalid-message]").slideDown();
        }
      });

      $container.find("[data-password-input]").on("keypress", function (e) {
        if (e.which == 13) {
          event.preventDefault();
          $container.find("[data-password-submit]").click();
        }
      });
    },
    initSlider: function () {
      var $container = this.$container,
        $slider = $container.find("[data-collection-lp-slider]");

      if ($slider.length) {
        $slider.slick({
          arrows: true,
          adaptiveHeight: true,
          infinite: false,
          slidesToShow: 4,
          slidesToScroll: 4,
          responsive: [
            {
              breakpoint: 990,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
              },
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
          ],
        });
      }
    },
    pageModal: function () {
      this.$container.find("[data-page-popup-toggle]").magnificPopup({
        type: "ajax",
      });
      this.$container.find("[data-product-popup-toggle]").magnificPopup({
        type: "inline",
        mainClass: "mfp-fade",
        closeOnBgClick: true,
        closeBtnInside: true,
        closeOnContentClick: false,
        tClose: "x",
        removalDelay: 500,
      });
    },
  });
  return LPBuyProduct;
})();

theme.GridSlider = (function () {
  function GridSlider(container) {
    var $container = (this.$container = $(container));

    if ($container.attr("data-initialized") === "true") {
      return;
    }
    this.init();
  }
  GridSlider.prototype = $.extend({}, GridSlider.prototype, {
    init: function () {
      let $container = this.$container,
        slideSelector = $container.attr("data-slide-selector");
      ($slider = $container.find("[data-slider]")),
        ($slide = $container.find(slideSelector));

      if (!$slider.length) {
        return;
      }

      $slide.removeClass("grid__item").addClass("grid-slider__item");

      $slider
        .on("init", function () {
          $container.attr("data-initialized", "true");
        })
        .slick({
          arrows: true,
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 3,
          dots: false,
          infinite: false,
          responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
              },
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
          ],
        });
    },
  });
  return GridSlider;
})();

// @todo: cleanup - delete ??
theme.LPProductSlider = (function () {
  function LPProductSlider(container) {
    var $container = (this.$container = $(container));
    this.initSlider();
    this.initProductLink();
  }
  LPProductSlider.prototype = $.extend({}, LPProductSlider.prototype, {
    initSlider: function () {
      let $container = this.$container,
        $slider = $container.find("[data-slick-slider]");

      $slider.slick({
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: true,
        infinite: false,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              infinite: true,
            },
          },
          {
            breakpoint: 479,
            settings: {
              arrows: false,
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    },
    initProductLink: function () {
      let $container = this.$container,
        $lpBuySection = $("#section-buy-product"),
        $productLink = $container.find("[data-product-link]");

      if (!$lpBuySection.length) {
        return;
      }

      $productLink.click(function (evt) {
        evt.preventDefault();
        let url = $(this).attr("href");
        $container.find(`[data-product-slide]`).removeClass("active");
        $(this).closest(`[data-product-slide]`).addClass("active");
        $lpBuySection
          .find(`[data-color-nav-link]`)
          .first()
          .attr("href", url)
          .click();
        // $lpBuySection.append( `<a href="${url}}" data-color-nav-link data-color-nav-link-dynamic></a>`);
        // $lpBuySection.find(`[data-color-nav-link-dynamic]`).click();
      });
    },
  });
  return LPProductSlider;
})();

// Scrollable section function
theme.makeScrollable = function makeScrollable(sectionId) {
  const sectionBlocksScrollable = document.querySelector(
    `#shopify-section-${sectionId} .section_blocks_scrollable`
  );
  if (!sectionBlocksScrollable) return;
  let scrollableWrapper = sectionBlocksScrollable.querySelector(
    ".section_blocks_content_wrapper"
  );
  if (!scrollableWrapper) {
    scrollableWrapper = sectionBlocksScrollable;
  }
  let isDown = false;
  let isDragging = false;
  let startX;
  let scrollLeft;
  let startY;
  let positions = [];
  let isDraggingLeft = null;
  let isDraggingRight = null;

  const startScroll = (e) => {
    isDown = true;
    isDragging = false;
    startX =
      (e.touches ? e.touches[0].clientX : e.pageX) -
      sectionBlocksScrollable.offsetLeft;
    startY = e.touches ? e.touches[0].clientY : e.pageY;
    scrollLeft = sectionBlocksScrollable.scrollLeft;
  };

  const stopScroll = (e) => {
    isDown = false;
    // Make all links clickable again
    const links = sectionBlocksScrollable.querySelectorAll("a");
    links.forEach((link) => {
      link.style.pointerEvents = "auto";
    });

    // Check which child elements are visible
    const children = Array.from(scrollableWrapper.children);

    const visibleChildren = children
      .map((child) => {
        return {
          element: child,
          indexPosition: children.indexOf(child),
        };
      })
      .filter((child) => {
        const rect = child.element.getBoundingClientRect();
        const parentRect = sectionBlocksScrollable.getBoundingClientRect();
        const visibleWidth = parentRect.width;
        const relativeLeft =
          (rect.left - parentRect.left) / (e.type === "touchend" ? 3 : 1);
        const relativeRight =
          (rect.right - parentRect.left) / (e.type === "touchend" ? 3 : 1);

        return relativeLeft >= 0 && relativeRight <= visibleWidth;
      });

    if (isDragging && visibleChildren.length > 0) {
      // Calculate the left position of the current and next child
      const firstChild = children[0];
      const lastChild = children[children.length - 1];

      const isFirstChild = firstChild === visibleChildren[0].element;
      const isLastChild = lastChild === visibleChildren[0].element;

      const elementWidth = visibleChildren[0].element.offsetWidth;
      const gap = parseInt(
        window.getComputedStyle(scrollableWrapper).gap.split("px")[0] || 0
      );

      // If the user has dragged the content to the left
      if (isDraggingLeft) {
        // Scroll to the next child element
        sectionBlocksScrollable.scrollTo({
          left: isLastChild
            ? sectionBlocksScrollable.scrollWidth
            : (elementWidth + gap) * visibleChildren[0].indexPosition,
          behavior: "smooth",
        });
      } else if (isDraggingRight) {
        // Scroll to the current child element
        sectionBlocksScrollable.scrollTo({
          left: isFirstChild
            ? 0
            : (elementWidth + gap) * (visibleChildren[0].indexPosition - 1),
          behavior: "smooth",
        });
      }
    }

    // Reset positions and the drag direction
    positions = [];
    isDraggingLeft = null;
    isDraggingRight = null;

    // Get the custom scrollbar elements
    const customScrollThumb = document.querySelector(
      `#shopify-section-${sectionId} .custom_scroll_thumb`
    );

    if (customScrollThumb) {
      // Calculate the width of the thumb relative to the content
      const scrollWidthRatio =
        sectionBlocksScrollable.clientWidth /
        sectionBlocksScrollable.scrollWidth;
      customScrollThumb.style.width = `${scrollWidthRatio * 100}%`;

      // Update the position of the thumb when the content is scrolled
      sectionBlocksScrollable.addEventListener("scroll", () => {
        const scrollLeftRatio =
          sectionBlocksScrollable.scrollLeft /
          sectionBlocksScrollable.scrollWidth;
        customScrollThumb.style.left = `${scrollLeftRatio * 100}%`;
      });
    }

    themeUtils.general.debounce(checkButtonStatus, 500)();
    // Reset the dragging flag
    setTimeout(() => {
      isDragging = false;
    }, 0);
  };

  const scroll = (e) => {
    if (!isDown) return;
    isDragging = true;

    // make all links unclickable while dragging adding pointer-events: none
    const links = sectionBlocksScrollable.querySelectorAll("a");
    links.forEach((link) => {
      link.style.pointerEvents = "none";
    });
    const isTouchEvent = e.type === "touchmove";
    const x =
      (isTouchEvent ? e.touches[0].clientX : e.pageX) -
      sectionBlocksScrollable.offsetLeft;
    const y = isTouchEvent ? e.touches[0].clientY : e.pageY;
    const walk = (x - startX) * 1.5; // Adjust scroll speed
    const verticalMovement = Math.abs(y - startY);
    const horizontalMovement = Math.abs(walk);

    // If the user has moved their finger vertically more than horizontally
    if (verticalMovement > horizontalMovement) {
      isDown = false;
      isDragging = false;
      return;
    }

    // If the user has moved their finger horizontally more than vertically
    if (horizontalMovement > verticalMovement && e.cancelable) {
      e.preventDefault();
      sectionBlocksScrollable.scrollLeft = scrollLeft - walk;
    }

    // Update isDraggingLeft and isDraggingRight
    positions.push(x);
    if (positions.length > 5) {
      // Change this number to adjust the sensitivity
      positions.shift();
    }
    if (positions.length > 1) {
      isDraggingLeft = x < positions[0];
      isDraggingRight = x > positions[0];
    }
  };

  ["mousedown", "touchstart"].forEach((event) => {
    sectionBlocksScrollable.addEventListener(event, startScroll);
  });

  ["mouseup", "touchend"].forEach((event) => {
    // Add the event listener to the document instead of the scrollable element
    if (event === "mouseup") {
      document.addEventListener(event, stopScroll);
    } else if (event === "touchend") {
      sectionBlocksScrollable.addEventListener(event, stopScroll);
    }
  });

  ["mousemove", "touchmove"].forEach((event) => {
    sectionBlocksScrollable.addEventListener(event, scroll);
  });

  const links = sectionBlocksScrollable.querySelectorAll("a");
  links.forEach((link) => {
    link.addEventListener("click", (e) => {
      if (isDragging) {
        e.preventDefault();
        e.stopPropagation();
      }
    });
  });

  const images = sectionBlocksScrollable.querySelectorAll("img");
  images.forEach((img) => {
    img.addEventListener("dragstart", (e) => e.preventDefault());
  });

  const buttonSliderControl = document.querySelector(
    `#shopify-section-${sectionId} .section_blocks_slider_control`
  );

  const prevButton = document.querySelector(
    `#shopify-section-${sectionId} .section_blocks_slider_prev`
  );
  const nextButton = document.querySelector(
    `#shopify-section-${sectionId} .section_blocks_slider_next`
  );

  function checkButtonStatus() {
    let isDisabledPrev = false;
    let isDisabledNext = false;
    // If the scrollable element is at the start
    if (sectionBlocksScrollable.scrollLeft === 0) {
      prevButton?.classList.add("disabled");
      isDisabledPrev = true;
    } else {
      prevButton?.classList.remove("disabled");
      isDisabledPrev = false;
    }

    // If the scrollable element is at the end
    if (
      sectionBlocksScrollable.scrollLeft +
        sectionBlocksScrollable.offsetWidth >=
      sectionBlocksScrollable.scrollWidth
    ) {
      nextButton?.classList.add("disabled");
      isDisabledNext = true;
    } else {
      nextButton?.classList.remove("disabled");
      isDisabledNext = false;
    }

    // hide the buttons if both are disabled
    if (isDisabledNext && isDisabledPrev) {
      if (prevButton && nextButton) {
        buttonSliderControl.style.opacity = "0";
      }
    } else {
      if (prevButton && nextButton) {
        buttonSliderControl.style.opacity = "1";
      }
    }
  }

  const sectionBlocksContentWrapperFirstChild = scrollableWrapper.children[0];

  const scrollContent = (direction) => {
    const sizeOfFirstChild = sectionBlocksContentWrapperFirstChild.offsetWidth;
    // calculate the gap of the parent flex container
    const gap = parseInt(
      window.getComputedStyle(scrollableWrapper).gap.split("px")[0] || 0
    );
    // Scroll one child element to the left or right based on the direction
    sectionBlocksScrollable.scrollBy({
      left: direction * (sizeOfFirstChild + gap),
      behavior: "smooth",
    });
    themeUtils.general.debounce(checkButtonStatus, 500)();
  };

  prevButton?.addEventListener("click", () => {
    scrollContent(-1); // Scroll to the left
  });

  nextButton?.addEventListener("click", () => {
    scrollContent(1); // Scroll to the right
  });

  themeUtils.general.debounce(checkButtonStatus, 500)();

  // add an intersection observer to sectionBlocksScrollable and run checkButtonStatus when it is in view the stop observing
  const observerScrollabe = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        checkButtonStatus();
        observerScrollabe.disconnect();
      }
    });
  });

  observerScrollabe.observe(sectionBlocksScrollable);
};

theme.featuredProductgenderToggle = function featuredProductgenderToggle(
  sectionId
) {
  const section = document.querySelector(`#shopify-section-${sectionId}`);
  const buttons = section.querySelectorAll(
    ".section_blocks_container .gender_toggle button"
  );
  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      buttons.forEach((button) => {
        button.classList.remove("active");
      });
      button.classList.add("active");
      const dataGender = button.dataset.genderTarget;
      if (dataGender) {
        toggleGenderFunction(dataGender);
      }
    });
  });
  const toggleGenderFunction = (dataGender) => {
    const productCards = section.querySelectorAll(
      ".section_blocks_product_item"
    );

    productCards.forEach((card) => {
      const hasDataGender = card.dataset.gender === dataGender;
      if (hasDataGender || card.dataset.gender === "any") {
        card.style.display = "flex";
      } else {
        card.style.display = "none";
      }
    });

    let visibleCardsCount = 0;

    productCards.forEach((card) => {
      if (card.style.display === "flex") {
        visibleCardsCount++;
      }
    });
    // set new value for --blocks-size
    section.style.setProperty("--blocks-size", visibleCardsCount);
    theme.makeScrollable(sectionId);
  };
  toggleGenderFunction("women");
};

// Focal Point Script
// Focal Point needs to run after the DOM is loaded because it needs to access the loaded elements
window.addEventListener("DOMContentLoaded", () => {
  theme.loadFocalPoints();
});
theme.loadFocalPoints = function loadFocalPoints() {
  function showFocalPoint() {
    // Find all .focal_point elements on the page
    const focalPoints = document.querySelectorAll(".focal_point");

    // Loop through all .focal_point elements
    focalPoints.forEach(function (element) {
      element.style.display = "flex";

      const focalCloseButton = element.nextElementSibling.querySelector(
        ".focal_point_product_close"
      );

      const focalPointProduct = element.nextElementSibling;

      console.log(focalPointProduct, ' focalPointProduct');
      function positionFocalPoint() {
        // get data-focal-left and data-focal-top attributes from .focal_point element and position it accordingly
        const focalLeft = element.getAttribute("data-focal-left");
        const focalTop = element.getAttribute("data-focal-top");
        const focalLeftMobile = element.getAttribute("data-focal-left-mobile");
        const focalTopMobile = element.getAttribute("data-focal-top-mobile");

        if (window.innerWidth <= 480 && focalLeftMobile && focalTopMobile) {
          element.style.left = focalLeftMobile + "%";
          element.style.top = focalTopMobile + "%";
        } else {
          element.style.left = focalLeft + "%";
          element.style.top = focalTop + "%";
        }
      }

      function showProduct() {
        focalPoints.forEach((el) => el.classList.remove("active"));
        element.classList.toggle("active");
        window.dataLayer = window.dataLayer || [];
        const productDataTitle = element.getAttribute(
          "data-focal-product-title"
        );
        const productDataId = element.getAttribute("data-focal-product-id");
        const productDataSKU = element.getAttribute("data-focal-product-sku");
        const productDataType = element.getAttribute("data-focal-product-type");
        window.dataLayer.push({
          event: "focalPointProductView",
          focalPointProduct: {
            id: productDataId,
            title: productDataTitle,
            sku: productDataSKU,
            type: productDataType,
            event_id: window.crypto.randomUUID
              ? window.crypto.randomUUID()
              : String(Math.random()).replace("0.", ""),
          },
        });
        const focalPointProduct = element.nextElementSibling;
        ensureVisibleHorizontally(focalPointProduct);
        // Add event listener to document object to hide .focal_point on click outside of element
        document.addEventListener("click", hideProduct);
      }

      function hideProduct(event) {
        var target = event.target;

        // Check if click event target is outside of .focal_point and .focal_point_product elements
        if (
          (!target.closest(".focal_point") &&
            !target.closest(".focal_point_product")) ||
          event.type === "mouseleave"
        ) {
          element.classList.remove("active");
          // Remove event listener from document object
          document.removeEventListener("click", hideProduct);
        }
      }

      positionFocalPoint();

      // Add event listener to .focal_point element to show .focal_point_product on hover or touch
      element.addEventListener("click", showProduct);
      element.addEventListener("touchstart", showProduct);
      element.addEventListener("mouseenter", showProduct);
      // hide .focal_point_product on mouseleave the parent element
      focalPointProduct.addEventListener("mouseleave", hideProduct);
      if (focalCloseButton)
        focalCloseButton.addEventListener("click", () => {
          // remove active class from .focal_point elements
          focalPoints.forEach((el) => el.classList.remove("active"));
        });

      // Add event listener to window object to reposition .focal_point element on resize only if window width is more or less than 768px
      window.addEventListener(
        "resize",
        themeUtils.general.throttle(function () {
          if (window.innerWidth <= 480) {
            positionFocalPoint();
          } else if (window.innerWidth >= 480) {
            positionFocalPoint();
          }
        }, 250) // Adjust the delay as needed
      );
    });
  }
  function ensureVisibleHorizontally(element) {
    setTimeout(() => {
      const viewportWidth =
        window.innerWidth || document.documentElement.clientWidth;
      const elementRect = element.getBoundingClientRect();
      const elementLeft = elementRect.left;
      const elementRight = elementRect.right;
      const elementWidth = elementRect.width;

      // get parent element of .focal_point_product
      const parentElement = element.parentElement;
      const parentElementRect = parentElement.getBoundingClientRect();
      const parentElementLeft = parentElementRect.left;
      const parentElementRight = parentElementRect.right;

      if (elementLeft < 0 || elementLeft < parentElementLeft) {
        element.style.left = "10%";
        element.style.right = "auto";
      } else if (
        elementRight > viewportWidth ||
        elementRight > parentElementRight
      ) {
        element.style.right = "10%";
        element.style.left = "auto";
      }
    }, 320);
  }

  showFocalPoint();
};

theme.changeCurrency = function changeCurrency() {
  const currencySelectorForm = document.getElementById(
    "desktop-currency-selector"
  );
  if (!currencySelectorForm) return;
  const currencySelector = currencySelectorForm.querySelector("select");
  currencySelector.addEventListener("change", function () {
    currencySelectorForm.submit();
  });
};

theme.openVideoModal = function openMagnificPopup(id, modalId) {
  const video = document.getElementById(modalId).querySelector("video");
  const modal = $(id).magnificPopup({
    type: "inline",
    mainClass: "mfp-fade",
    closeOnBgClick: true,
    closeBtnInside: true,
    closeOnContentClick: false,
    tClose: "x",
    removalDelay: 500,
    callbacks: {
      open: function () {
        if (video) {
          video.play();
          // hide class mfp-preloader
          const preloader = document.querySelector(".mfp-preloader");
          if (preloader) {
            preloader.style.display = "none";
          }
          // scroll to the id
          const element = document.getElementById(id.replace("#", ""));
          if (element) {
            // scroll smoothly to the center of the element
            element.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          }
        }
      },
      close: function () {
        if (video) {
          video.pause();
        }
      },
    },
  });
  modal.magnificPopup("open");
};

// GTM Push Function

/**
 * Attaches event listeners to elements with data-pushgtm attributes.
 * Parses data-pushgtm-event and data-pushgtm-data and pushes to dataLayer.
 */

/* Examplas of data-pushgtm elements
<button
  data-pushgtm
  data-pushgtm-event="click"
  data-pushgtm-data='{"event": "add-to-cart", "data": {"id": 1, "someData": "some_data"}}'
>
  Add to Cart
</button>

<a
  href="#"
  data-pushgtm
  data-pushgtm-event="click"
  data-pushgtm-data='{"event": "product-link-click", "data": {"productId": "123", "productName": "Example"}}'
>
  View Product
</a>

<form data-pushgtm data-pushgtm-event="submit" data-pushgtm-data='{"event": "form-submit", "data": {"formId": "contact-form"}}'>
    <input type="text" name="name">
    <button type="submit">Submit</button>
</form>
*/
theme.setupDataLayerTriggers = function() {
  const elements = document.querySelectorAll('[data-pushgtm]');

  elements.forEach(element => {
    const eventType = element.getAttribute('data-pushgtm-event');
    const eventDataString = element.getAttribute('data-pushgtm-data');

    if (eventType && eventDataString) {
      element.addEventListener(eventType, () => {
        try {
          const eventData = JSON.parse(eventDataString);
          themeUtils.general.pushDataLayerEvent(eventData);
        } catch (error) {
          console.error('Error parsing data-pushgtm-data:', error);
        }
      });
    } else {
      console.warn('data-pushgtm element missing data-pushgtm-event or data-pushgtm-data attributes.');
    }
  });
}

themeInit = function () {
  console.log("themeInit");
};

// Lazy Load Video
window.addEventListener("themeIsLoaded", initLazyVideoLoading);

function initLazyVideoLoading() {
  const lazyVideos = Array.from(document.querySelectorAll("video.lazy-video"));

  if ("IntersectionObserver" in window) {
    const lazyVideoObserver = createLazyVideoObserver();

    lazyVideos.forEach((lazyVideo) => {
      lazyVideoObserver.observe(lazyVideo);
    });
  }
}

function createLazyVideoObserver() {
  return new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting && !entry.target.dataset.loaded) {
        processVideoEntry(entry.target);
      }
    });
  });
}

function processVideoEntry(video) {
  updateVideoSources(video);
  video.load();

  if (!video.classList.contains("no-autoplay")) {
    video.addEventListener("loadedmetadata", function handleCanPlay() {
      attemptVideoPlay(video);
      video.removeEventListener("loadedmetadata", handleCanPlay);
    });
  } else {
    video.pause();
  }

  video.classList.remove("lazy-video");
}

function updateVideoSources(videoElement) {
  const sources = Array.from(videoElement.children).filter(
    (child) => child.tagName === "SOURCE"
  );

  sources.forEach((source) => {
    source.src = source.dataset.src;
  });
}

function attemptVideoPlay(video) {
  if (!video.paused) return;

  const videoPlayPromise = video.play();

  if (videoPlayPromise !== undefined) {
    videoPlayPromise
      .then(() => {
        // add playing class to the video wrapper child video-controls check
        video
          .closest(".video-wrapper")
          ?.querySelector(".video-controls")
          ?.classList.add("playing");
      })
      .catch((error) => {
        // Auto-play was prevented
        console.error(error);
      });
  }

  video.dataset.loaded = true;
}

const playPauseButton = document.querySelectorAll(".video-playPauseBtn");
playPauseButton.forEach(function (el) {
  el.addEventListener("click", function (t) {
    // go the the parent video wrapper and find the video
    const classBreakPoint =
      window.innerWidth < 480
        ? "video_mobile"
        : window.innerWidth < 768
          ? "video_tablet"
          : "video_desktop";
    const video = el
      .closest(".video-wrapper")
      .querySelector(`video.${classBreakPoint}`);
    if (video.paused) {
      const videoPlayPromise = video.play();
      if (videoPlayPromise !== undefined) {
        videoPlayPromise
          .then(() => {
            // add playing class to the video wrapper child video-controls
            el.classList.add("playing");
          })
          .catch((error) => {
            // Auto-play was prevented
            console.error(error);
          });
      }
    } else {
      video.pause();
      el.classList.remove("playing");
    }
  });
});

// INIT THEME
window.themeIsLoaded = true;
themeInit();
dispatchEvent(new Event("themeIsLoaded"));
